<template>
  <v-col cols="12">
    <v-card elevation="0" color="grey lighten-5">
      <v-col cols="12">
        <h1>{{ $t("profile.title") }}</h1>
        <v-row>
          <v-col cols="12" md="6">
            <v-col cols="12">
              <h2>{{ $t("profile.coordinates.title") }}</h2>
              <v-form
                ref="coordinatesForm"
                style="position: relative"
                v-model="coordinatesValid"
                lazy-validation
              >
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="profile.user_company"
                  :rules="[
                    (v) => !!v || $t('profile.coordinates.companyError'),
                  ]"
                  :label="$t('profile.coordinates.company')"
                  required
                ></v-text-field>
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="profile.user_nom"
                  :rules="[
                    (v) => !!v || $t('profile.coordinates.lastnameError'),
                  ]"
                  :label="$t('profile.coordinates.lastname')"
                  required
                ></v-text-field>
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="profile.user_prenom"
                  :rules="[
                    (v) => !!v || $t('profile.coordinates.firstnameError'),
                  ]"
                  :label="$t('profile.coordinates.firstname')"
                  required
                ></v-text-field>
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="profile.user_adresse"
                  :rules="[
                    (v) => !!v || $t('profile.coordinates.addressError'),
                  ]"
                  :label="$t('profile.coordinates.address')"
                  required
                ></v-text-field>
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="profile.user_adresse_2"
                  :label="$t('profile.coordinates.address2')"
                ></v-text-field>
                <v-row>
                  <v-col>
                    <v-text-field
                      filled
                      rounded
                      dense
                      v-model="profile.user_cp"
                      :rules="[
                        (v) => !!v || $t('profile.coordinates.zipcodeError'),
                      ]"
                      :label="$t('profile.coordinates.zipcode')"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      filled
                      rounded
                      dense
                      v-model="profile.user_ville"
                      :rules="[
                        (v) => !!v || $t('profile.coordinates.cityError'),
                      ]"
                      :label="$t('profile.coordinates.city')"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="profile.user_pays"
                  :rules="[
                    (v) => !!v || $t('profile.coordinates.countryError'),
                  ]"
                  :label="$t('profile.coordinates.country')"
                  required
                ></v-text-field>
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="profile.user_phone"
                  :rules="[
                    (v) => !!v || $t('profile.coordinates.phoneError'),
                    (v) =>
                      /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/.test(
                        v
                      ) || $t('profile.coordinates.phoneInvalid'),
                  ]"
                  :label="$t('profile.coordinates.phone')"
                  required
                ></v-text-field>
                <v-col class="text-right">
                  <v-btn
                    rounded
                    elevation="0"
                    :disabled="!coordinatesValid"
                    color="success"
                    class="mr-4"
                    @click="coordinatesValidate"
                  >
                    {{ $t("profile.coordinates.submitBtn") }}
                  </v-btn>
                </v-col>
              </v-form>
            </v-col>
          </v-col>
          <v-col cols="12" md="6">
            <v-col cols="12">
              <h2>{{ $t("profile.email.title") }}</h2>
              <v-form
                ref="emailForm"
                style="position: relative"
                v-model="emailValid"
                lazy-validation
              >
                <v-text-field
                  filled
                  rounded
                  dense
                  disabled
                  v-model="user.user_email"
                  :label="$t('profile.email.actualEmail')"
                  required
                ></v-text-field>
                <v-text-field
                  v-if="editMail"
                  filled
                  rounded
                  dense
                  v-model="change_email.new_user_email"
                  :rules="[
                    (v) => !!v || $t('profile.email.emailError'),
                    (v) =>
                      /.+@.+\..+/.test(v) || $t('profile.email.emailInvalid'),
                  ]"
                  :label="$t('profile.email.newEmail')"
                  required
                ></v-text-field>
                <v-text-field
                  v-if="editMail"
                  filled
                  rounded
                  dense
                  type="password"
                  v-model="change_email.user_password"
                  :label="$t('profile.email.password')"
                  required
                ></v-text-field>
                <v-col class="text-right">
                  <v-btn
                    v-if="editMail"
                    rounded
                    elevation="0"
                    :disabled="!emailValid"
                    color="success"
                    class="mr-4"
                    @click="emailValidate"
                  >
                    {{ $t("profile.email.submitBtn") }}
                  </v-btn>
                  <v-btn
                    v-else
                    rounded
                    elevation="0"
                    :disabled="!emailValid"
                    color="success"
                    class="mr-4"
                    @click="editMail = true"
                  >
                    {{ $t("profile.email.editMail") }}
                  </v-btn>
                </v-col>
              </v-form>
            </v-col>

            <v-divider />
            <v-col cols="12">
              <h2>{{ $t("profile.password.title") }}</h2>
              <v-form
                ref="passwordForm"
                style="position: relative"
                v-model="passwordValid"
                lazy-validation
              >
                <v-text-field
                  filled
                  rounded
                  v-if="editPass"
                  dense
                  type="password"
                  v-model="new_password.user_password"
                  :label="$t('profile.password.actualPassword')"
                  required
                ></v-text-field>
                <v-text-field
                  filled
                  rounded
                  v-if="editPass"
                  dense
                  type="password"
                  v-model="new_password.new_user_password"
                  :label="$t('profile.password.newPassword')"
                  required
                ></v-text-field>
                <v-text-field
                  filled
                  rounded
                  v-if="editPass"
                  dense
                  type="password"
                  :label="$t('profile.password.passwordConfirm')"
                  :rules="[
                    (v) =>
                      v === new_password.new_user_password ||
                      $t('profile.password.passwordError'),
                  ]"
                  required
                ></v-text-field>
                <v-col class="text-right">
                  <v-btn
                    v-if="editPass"
                    elevation="0"
                    :disabled="!passwordValid"
                    color="success"
                    class="mr-4"
                    block
                    @click="passwordValidate"
                  >
                    {{ $t("profile.password.submitBtn") }}
                  </v-btn>
                  <v-btn
                    v-else
                    rounded
                    elevation="0"
                    :disabled="!passwordValid"
                    color="success"
                    class="mr-4"
                    @click="editPass = true"
                  >
                    {{ $t("profile.password.editBtn") }}
                  </v-btn>
                </v-col>
              </v-form>
            </v-col>
            <v-divider />
            <v-col cols="12">
              <h2>{{$t('profile.interface_language')}}</h2>
              <v-select v-model="profile.lang" :label="$t('profile.interface_language')" rounded filled dense :items='[{text:"Français", value:"FR"}, {text:"English", value:"EN"}]'/>
              <v-col class="text-right">
              <v-btn 
              rounded
              elevation="0"
              color="success"
              class="mr-4"
              @click="udpate_lang()">{{$t('profile.update_lang')}}</v-btn>
            </v-col>
            </v-col> 
            <v-divider />
            <v-col cols="12">
              <h2>{{$t('infos_abo')}}</h2>
              <v-col
                v-for="(abo, i) in user.roles_expirations"
                :key="`abo${i}`"
              >
                <v-card>
                  <v-card-title v-if="abo.id_role == 1">
                     Admin 
                     jusqu'au
                    {{ moment(abo.expiration).format("DD/MM/YYYY HH:mm") }}
                     </v-card-title>
                  <v-card-title
                    class="primary white--text font-weight-bold"
                    v-if="abo.id_role == 2"
                  >
                    My 
                    <template v-if="abo.expiration">
                    jusqu'au
                    {{ moment(abo.expiration).format("DD/MM/YYYY HH:mm") }}
                    </template>
                  </v-card-title>
                  <v-card-title
                    class="primary white--text font-weight-bold"
                    v-if="abo.id_role == 3"
                  >
                    My+ 
                    <template v-if="abo.expiration">
                    jusqu'au
                    {{ moment(abo.expiration).format("DD/MM/YYYY HH:mm") }}
                    </template>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col v-if="!iOS" class="text-right">
                <v-btn
                  color="success"
                  rounded
                  target="_blank"
                  href="https://services.previmeteo.com/fr/abonnement-bulletin-meteo.php"
                  >{{$t('renew')}}</v-btn
                >
              </v-col>
            </v-col>
            <v-divider />
            <v-col cols=12 class="text-right">
              <v-btn color="error" @click="logout" rounded>{{$t('logout')}}</v-btn>
            </v-col>
            <v-divider />
            <v-col cols="12" v-if="!iOS && $env.VUE_APP_WHITE_MARK_ID != 'fp'"> 
              <a
                href="https://play.google.com/store/apps/details?id=com.previmeteo.alerts&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                ><img
                  width="200px"
                  alt="Disponible sur Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png"
              /></a>
            </v-col>
            <v-col cols="12">
              <a @click="deleteAccountModal = true" color="primary" rounded dense>Demande de suppression de compte</a>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
    <v-dialog  max-width="300px" style="z-index:10000000!important;" v-model="deleteAccountModal">
      <v-card>
        <v-card-title>
          <span class="headline">Suppression de compte</span>
        </v-card-title>
        <v-card-text>
          <h3>
            Voulez-vous confirmer la demande de suppression de votre compte ?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" @click="deleteAccountModal = false">Annuler</v-btn>
          <v-btn color="success" @click="deleteAccountDemand()">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" top>{{
      $t("profile.password.snackbarSuccess")
    }}</v-snackbar>
    <v-snackbar v-model="error" color="error" top>{{
      $t("profile.password.snackbarError")
    }}</v-snackbar>
  </v-col>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { mapState } from "vuex";
import api from "../../api";
import moment from "moment";
import axios from 'axios';
export default {
  computed: {
    ...mapState(["user"]),
    iOS() {
      return Capacitor.getPlatform() == 'ios' ? true:false;
    },
  },

  data() {
    return {
      editMail: false,
      moment: moment,
      editPass: false,
      profile: {
        user_company: null,
        user_nom: null,
        user_prenom: null,
        user_adresse: null,
        user_adresse_2: null,
        user_cp: null,
        user_ville: null,
        lang: null,
        user_pays: null,
        user_phone: null,
      },
      new_password: {
        user_password: null,
        new_user_password: null,
      },
      change_email: {
        user_email: null,
        new_user_email: null,
        user_password: null,
      },
      coordinatesValid: true,
      emailValid: true,
      passwordValid: true,
      success: false,
      error: false,
      deleteAccountModal: false,
    };
  },

  methods: {
    async udpate_lang()
    {
      try {
        await api.users.updateLang(this.user.id_user, this.profile.lang);
          this.success = true;
          this.$i18n.locale = this.profile.lang.toLowerCase();
        } catch (err) {
          console.log(err);
          this.error = err;
        }
    },
    async deleteAccountDemand()
    {
      api.deleteAccountDemand(this.user.user_email)
      this.deleteAccountModal = false;

    },
    setProfile() {
      let {
        user_company,
        user_nom,
        user_prenom,
        user_adresse_2,
        user_adresse,
        user_cp,
        user_ville,
        user_pays,
        lang,
        user_phone,
      } = this.user;

      console.log(this.user)

      this.profile = {
        user_company: user_company,
        user_nom: user_nom,
        user_prenom: user_prenom,
        user_adresse: user_adresse,
        user_adresse_2: user_adresse_2,
        user_cp: user_cp,
        lang: lang,
        user_ville: user_ville,
        user_pays: user_pays,
        user_phone: user_phone,
      };

      this.change_email.user_email = this.user.user_email;
    },

    async coordinatesValidate() {
      if (this.$refs.coordinatesForm.validate()) {
        try {
          await api.users.updateData(this.user.id_user, this.profile);
          this.success = true;
        } catch (err) {
          this.error = err;
        }
      }
    },
    logout() {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setToken", null);
      localStorage.removeItem("token")
      // localStorage.clear();
      this.$router.go("/login");
    },
    async emailValidate() {
      if (this.$refs.emailForm.validate()) {
        try {
          await api.users.updateEmail(this.user.id_user, this.change_email);
          this.success = true;
        } catch (err) {
          this.error = err;
        }
      }
    },

    async passwordValidate() {
      if (this.$refs.passwordForm.validate()) {
        try {
          await api.users.updatePassword(this.user.id_user, this.new_password);
          this.success = true;
        } catch (err) {
          this.error = err;
        }
      }
    },
  },

  mounted() {
    this.setProfile();
  },
};
</script>

<style>
</style>